import { apiClient } from './api-client';

export interface DepartmentHead {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  employeeCode: string | null;
}

export interface Department {
  id: string;
  tenantId: string;
  name: string;
  code: string;
  description: string | null;
  departmentType: string;
  isActive: boolean;
  isSystem: boolean;
  departmentHead: DepartmentHead | null;
  userCount: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface DepartmentListResponse {
  items: Department[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateDepartmentPayload {
  name: string;
  code: string;
  description?: string;
  departmentType?: string;
  departmentHeadUserId?: string | null;
}

export type UpdateDepartmentPayload = Partial<CreateDepartmentPayload> & {
  isActive?: boolean;
  departmentHeadUserId?: string | null;
};

export const departmentService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
    isActive?: boolean;
  }): Promise<DepartmentListResponse> =>
    apiClient.get<DepartmentListResponse>('/departments', { params }).then((r) => r.data),

  listAll: (): Promise<Department[]> =>
    apiClient.get<Department[]>('/departments/all').then((r) => r.data),

  get: (id: string): Promise<Department> =>
    apiClient.get<Department>(`/departments/${id}`).then((r) => r.data),

  create: (payload: CreateDepartmentPayload): Promise<Department> =>
    apiClient.post<Department>('/departments', payload).then((r) => r.data),

  update: (id: string, payload: UpdateDepartmentPayload): Promise<Department> =>
    apiClient.patch<Department>(`/departments/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/departments/${id}`).then(() => undefined),
};
